export interface FiltersType {
    id: string;
    value: string;
    label: string;
    disabled: boolean;
}

export const filtersGlobal: Array<FiltersType> = [
    {
        id: 'show-all',
        value: 'show-all',
        label: 'Show all',
        disabled: false,
    },
    {
        id: 'published',
        value: 'published',
        label: 'Published',
        disabled: false,
    },
    {
        id: 'unpublished',
        value: 'unpublished',
        label: 'Unpublished',
        disabled: false,
    },
    {
        id: 'archived',
        value: 'archived',
        label: 'Archived',
        disabled: true,
    },
];
